type BulkActionsBarProps = {
  selectedCount: number
  onClear: () => void
  onDelete: () => void
  disabled?: boolean
}

export default function BulkActionsBar({ selectedCount, onClear, onDelete, disabled }: BulkActionsBarProps) {
  if (selectedCount === 0) return null

  return (
    <div className="flex items-center justify-between gap-3 mb-3 px-4 py-2 rounded border border-red-500/20 bg-red-500/10">
      <span className="text-xs text-red-300">{selectedCount} selecionado{selectedCount > 1 ? 's' : ''}</span>
      <div className="flex items-center gap-2">
        <button className="btn-ghost" onClick={onClear} disabled={disabled}>Limpar</button>
        <button
          onClick={onDelete}
          disabled={disabled}
          className="text-xs bg-red-500/15 text-red-300 hover:bg-red-500/25 px-3 py-1.5 rounded transition-colors"
        >
          Excluir selecionados
        </button>
      </div>
    </div>
  )
}
